class PlayerInfoController {
  constructor(PlayersFactory, $rootScope, $stateParams, Levels) {
    "ngInject";
    const vm = this;

    vm.rootScope = $rootScope;
    vm.levels = [
      { id: Levels.WHITE, name: "White" },
      { id: Levels.BLACK, name: "Black" },
      { id: Levels.BLUE, name: "Blue" },
      { id: Levels.RED, name: "Red" },
      { id: Levels.YELLOW, name: "Yellow" },
      { id: Levels.GREEN, name: "Green" },
    ];

    vm.$onInit = () => {
      vm.playerId = $stateParams.id;
      vm.player = {};
      if (vm.playerId) {
        PlayersFactory.getOne(vm.playerId, {
          include: "team,state,citizenship,nationality",
        }).then((response) => {
          vm.player = response.data;
        });
      }
    };

    vm.getCompoundLevelName = () => {
      return vm.levels.find((l) => l.id === vm.player.compound_level).name;
    };

    vm.getRecurveLevelName = () => {
      return vm.levels.find((l) => l.id === vm.player.recurve_level).name;
    };
  }
}

export default PlayerInfoController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerInfo/playerInfo.controller.js